/**
 * @param {object} data
 * @param {string} flag
 * @returns {boolean}
 */
export const getFeatureFlagFromStore = (data, flag) => {
  try {
    if (!data) return false;

    return data[flag]?.value === "on";
  } catch (e) {
    return false;
  }
};
